/**
 * @description Gestion du sommaire
 */

(() => {
	// VARS

	// Fonctions
	const removeClass = () => {
		const sitemap = document.querySelector('.sitemap-item');
		// sitemap.querySelector('ul').classList.remove('header__menu');
		sitemap.querySelector('ul').classList.add('list-group');
		document.querySelectorAll('.sitemap-item button').forEach((button) => {
			button.remove();
		});
		sitemap.querySelectorAll('li').forEach((li) => {
			li.classList.add('list-group-item');
		});
		sitemap.querySelectorAll('button').forEach((el) => {
			el.remove();
		});
		sitemap.querySelectorAll('div').forEach((el) => {
			el.removeAttribute('id');
		});

		sitemap.querySelectorAll('ul').forEach((ul) => {
			ul.classList.remove(
				'header__menu',
				'header__menu__submenu',
				'header__menu__submenu-lvl-2',
				'header__menu__submenu-lvl-3'
			);
		});
	};
	const circle = () => {
		document
			.querySelectorAll('div ul li ul li ul li a')
			.forEach((element) => {
				element.insertAdjacentHTML(
					'afterbegin',
					"<div class='orange__circle'></div>"
				);
			});
	};

	// GO 🚀
	const init = () => {
		circle();
		removeClass();
	};

	init();
})();
